import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useSEO } from "@/hooks/useSEO";
import { useSettings } from "@/hooks/useSettings";

const SECTIONS = [
  {
    title: "1. მოითხოვე მძღოლისგან",
    text: "ავტომობილის დასაქირავებლად საჭიროა: მინიმუმ 26 წლის ასაკი, მინიმუმ 2 წლიანი მართვის გამოცდილება, მოქმედი პირადობის მოწმობა და მართვის მოწმობა. დამატებითი დეტალები დაზუსტდება ხელშეკრულების გაფორმებისას.",
  },
  {
    title: "2. საკურატორო თანხა (დეპოზიტი)",
    text: "ხელშეკრულების გაფორმებისას მძღოლი იხდის დეპოზიტს, რომლის ოდენობა დამოკიდებულია არჩეული ავტომობილის კატეგორიაზე. დეპოზიტი სრულად ბრუნდება ხელშეკრულების დასრულებისას, ავტომობილის შეთანხმებული პირობებით და დაზიანების გარეშე დაბრუნების შემთხვევაში.",
  },
  {
    title: "3. დღიური გადასახადი და უფასო კვირები",
    text: "იჯარა ირიცხება ყოველდღიურად კატალოგში მითითებული ტარიფით. კვირა დღეები უფასოა — იჯარა ამ დღეებში არ ირიცხება. გადახდის დეტალური გრაფიკი ფიქსირდება ხელშეკრულებაში.",
  },
  {
    title: "4. ტექნიკური მომსახურება და დაზღვევა",
    text: "ავტომობილის ტექნიკურ მომსახურებასა და სრულ დაზღვევას უზრუნველყოფს კომპანია. მძღოლი ვალდებულია დაუყოვნებლივ აცნობოს კომპანიას ნებისმიერი ტექნიკური ხარვეზის ან ინციდენტის შესახებ.",
  },
  {
    title: "5. ლიცენზია და ავტობუსის ზოლი",
    text: "A-კატეგორიის ტაქსის ლიცენზიას მძღოლს უზრუნველყოფს კომპანია. მოდელების ნაწილს აქვს ავტობუსის ზოლში (Bus Lane) მოძრაობის უფლება — კონკრეტული პირობები მითითებულია თითოეული ავტომობილის გვერდზე.",
  },
  {
    title: "6. ავტომობილის გამოყენება",
    text: "ავტომობილი გამოიყენება მხოლოდ ტაქსის მომსახურებისთვის და პირადი საჭიროებისთვის ხელშეკრულების ფარგლებში. ავტომობილის მესამე პირზე გადაცემა კომპანიის თანხმობის გარეშე აკრძალულია.",
  },
  {
    title: "7. ხელშეკრულების შეწყვეტა",
    text: "ორივე მხარეს შეუძლია ხელშეკრულების შეწყვეტა წინასწარი შეტყობინებით, ხელშეკრულებაში გათვალისწინებული ვადით. დეპოზიტი ბრუნდება ყველა ვალდებულების შესრულების შემდეგ.",
  },
];

export default function Terms() {
  const settings = useSettings();
  const custom = (settings.terms_text || "").trim();
  useSEO({
    title: "წესები და პირობები | taxipark.ge",
    description: "ტაქსის მანქანის ქირაობის წესები და პირობები: დეპოზიტები, დღიური გადასახადი, დაზღვევა და ლიცენზია.",
    path: "/terms",
  });

  return (
    <main data-testid="terms-page" className="pt-28 pb-8">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <p className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] font-semibold mb-3">დოკუმენტი</p>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-white">წესები და პირობები</h1>
        <p className="text-sm text-gray-500 mt-4">ბოლო განახლება: 2026 წელი</p>
        <div className="mt-12 space-y-10">
          {custom ? (
            custom.split("\n\n").map((p, i) => (
              <p key={i} className="text-gray-400 leading-relaxed whitespace-pre-line" data-testid={`terms-custom-${i}`}>{p}</p>
            ))
          ) : (
            SECTIONS.map((s, i) => (
              <section key={s.title} data-testid={`terms-section-${i}`}>
                <h2 className="text-xl font-semibold text-white mb-3">{s.title}</h2>
                <p className="text-gray-400 leading-relaxed">{s.text}</p>
              </section>
            ))
          )}
        </div>
        <div className="mt-14 card-lux p-8 text-center">
          <p className="text-gray-300">კითხვა გაქვს პირობებზე?</p>
          <Link to="/apply" data-testid="terms-apply-cta" className="btn-gold mt-5">დაგვიკავშირდი</Link>
        </div>
      </div>
    </main>
  );
}
